module.exports = __webpack_public_path__ + "img/CS2_section_1_static_circles-01.c944bd3b.png";